import React from "react";
import { MotifAnnulation, Order } from "./iMonCompte";
import { formatNumCommande } from './OrderAction';
import { formatPrice} from '../mon-compte/MonCompteAction';
import Icons  from "./Icons";
import RenderOrderLine from "./RenderOrderLine";

interface RenderSplitOrderLineProps {
    order: Order,
    children: Order[],
    motifsAnnulation: MotifAnnulation[],
    activateAnnulation: boolean,
    activateNewUpload: boolean
}

export default function RenderSplitOrderLine(props: RenderSplitOrderLineProps): JSX.Element {
    
    const childrenItems = props.children.map(elt => {
        return (
                <RenderOrderLine key={elt.idCommande} order={elt} paymentMethods={[]} oldOrder={false} fromSplitOrder
            motifsAnnulation={props.motifsAnnulation} activateAnnulation={props.activateAnnulation} activateNewUpload={props.activateNewUpload} />
        )
    });

    return (
        <div className="parentOrderLineContainer">
            <div className="d-flex justify-content-between  parentOrderLine black font14">
                <span className="d-flex align-items-center">
                    <Icons icon="ic-splitted" size={14} color={'black'}/>
                    <span className="bold ml05 mr05">
                    {formatNumCommande(props.order.numCommande)} 
                    </span> (Multi-entrepôts)
                </span>
                <span className="bold">Prix total :  {formatPrice(props.order.TotalTTC)} &euro;</span>
            </div>
            <div className="childsOrderLineContainer">
            {childrenItems}
            </div>
        </div>
    )
}